import React, { useEffect, useState } from 'react';
import { Nav, NavItem } from 'reactstrap';
import styles from 'styles/Report.module.scss';
import classnames from 'classnames';
import { Dropdown, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Router, { useRouter } from 'next/router';

import { getViewMode } from 'store/auth';
import { useUser } from 'hooks';
const Menu = () => {
  const viewMode = useSelector(getViewMode);
  const user = useUser();
  const [showFevIcon, setShowFevIcon] = useState(false);
  const { query } = useRouter();
  const activeMenuColor = 'var(--menu-bg-clr)';
  const [iscompanyMenu, setIsCompanyMenu] = useState(false);
  const [isaboutus, setIsAboutUs] = useState(false);
  const [iscontactus, setIsContactUs] = useState(false);

  const handleMouseEnter = async (type) => {
    switch (type) {
      case 'companymenu-hover':
        setIsCompanyMenu(true);
        break;
      case 'aboutus-hover':
        setIsAboutUs(true);
        break;
      case 'contactus-hover':
        setIsContactUs(true);
        break;
    }
  };
  const handleMouseLeave = async (type) => {
    switch (type) {
      case 'companymenu-hover':
        setIsCompanyMenu(false);
        break;
      case 'aboutus-hover':
        setIsAboutUs(false);
        break;
      case 'contactus-hover':
        setIsContactUs(false);
        break;
    }
  };

  const onFooterClick = async (footerType) => {
    switch (footerType) {
      case 'aboutUs-type':
        let aboutUs = { type: 'aboutUs' };
        Router.push({
          pathname: user?._id ? '/lms-user/footer' : '/homes/footer/aboutus',
          query: aboutUs,
        });
        break;
      case 'contactUs-type':
        let contactUs = { type: 'contactUs' };
        Router.push({
          pathname: user?._id ? '/lms-user/footer' : '/homes/footer/contactus',
          query: contactUs,
        });
        break;
    }
  };

  return (
    <div className="menulistitem">
      <Nav navbar>
        <NavItem>
          <div className="header__nav-link drop-menu">
            <Dropdown
              className={classnames(
                'pr-0',
                'align-text-top',
                'mega-dropdown-menu-company mega-dropdown-width',
              )}
            >
              <div
                onClick={() => setShowFevIcon(!showFevIcon)}
                style={{ marginTop: 2 }}
                // className={classnames('menu-icon', styles['menu-icon'])}
              >
                <Dropdown.Toggle variant="none">
                  <button
                    className={classnames(
                      'company-menu-btn',
                      'company-menu',
                      styles['company-menu'],
                      'home-icon btn  p-0 pl-1',
                    )}
                    style={{
                      color: iscompanyMenu
                        ? activeMenuColor
                        : query?.type === 'aboutUs' ||
                          query?.type === 'contactUs'
                        ? activeMenuColor
                        : '',
                    }}
                    onMouseEnter={() => handleMouseEnter('companymenu-hover')}
                    onMouseLeave={() => handleMouseLeave('companymenu-hover')}
                  >
                    Company
                  </button>
                </Dropdown.Toggle>
              </div>
              <div>
                <Dropdown.Menu
                  className={classnames(
                    'menu-cardshade',
                    styles['menu-cardshade'],
                  )}
                >
                  <Row>
                    <div className={classnames('col-md-3 col-xs-12')}>
                      <div>
                        <Dropdown.Item className="pt-0">
                          {'  '}
                          <div
                            className="nav-link-a"
                            style={{
                              display: 'flex',
                              color: isaboutus
                                ? activeMenuColor
                                : Router?.pathname === '/homes/footer/aboutus'
                                ? activeMenuColor
                                : '',
                            }}
                            onMouseEnter={() =>
                              handleMouseEnter('aboutus-hover')
                            }
                            onMouseLeave={() =>
                              handleMouseLeave('aboutus-hover')
                            }
                          >
                            <span
                              className="menu-company"
                              style={{ marginTop: -4, marginLeft: 20 }}
                              onClick={() => onFooterClick('aboutUs-type')}
                            >
                              {' '}
                              &nbsp; About Us{' '}
                            </span>
                          </div>
                        </Dropdown.Item>
                        <Dropdown.Item className="pt-0">
                          {'  '}
                          <div
                            className="nav-link-a"
                            style={{
                              display: 'flex',
                              color: iscontactus
                                ? activeMenuColor
                                : Router?.pathname === '/homes/footer/contactus'
                                ? activeMenuColor
                                : '',
                            }}
                            onMouseEnter={() =>
                              handleMouseEnter('contactus-hover')
                            }
                            onMouseLeave={() =>
                              handleMouseLeave('contactus-hover')
                            }
                          >
                            <span
                              className="menu-company"
                              style={{ marginTop: -4, marginLeft: 20 }}
                              onClick={() => onFooterClick('contactUs-type')}
                            >
                              {' '}
                              &nbsp; Contact Us{' '}
                            </span>
                          </div>
                        </Dropdown.Item>
                      </div>
                    </div>
                  </Row>
                </Dropdown.Menu>
              </div>
            </Dropdown>
          </div>
        </NavItem>
      </Nav>
    </div>
  );
};

export default Menu;
